<script setup>
  import { RouterView, useRoute } from 'vue-router'
  import CollectionNav from '@/components/Navigation/CollectionNav.vue'
  import GinnelNav from '@/components/Navigation/GinnelNav.vue'
  import Navbar from '@/components/Navigation/Navbar.vue'
  import Footer from '@/components/Content/Footer.vue'

  const route = useRoute()
</script>

<template>
  <Navbar />
   <div class="wrapper">
     <div class="cg-container row h-100 m-auto">
         <RouterView />
     </div>
   </div>
  <Footer />
</template>